/*eslint-disable @typescript-eslint/restrict-plus-operands */
import { FC, useContext, useEffect, useState } from "react";
import clsx from "clsx";
import { Button } from "@ht/components";
import VideoOnIcon from "@ht/shared/fonts/deos-pis/video-on";
import SadIcon from "@ht/shared/fonts/deos-pis/emoji-sad";
import CloseIcon from "@ht/shared/fonts/deos-pis/close";


import { IVCallIncomingMessage, IVCallState } from "../../../../app/videocall/types";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { vCallIncomingMessageReceived, vCallSendMessage, vCallStateChanged } from "../../../../app/videocall/videoSlice";
import { setFloatingCoordinate, setOverlay } from "../../../../app/layout/layoutStateSlice";
import { toIsoString, uid } from "@ht/shared/methods";
import { now } from "moment";
import { useDragging } from "../../../../hooks/useDragging";

import { AntmediaContext } from "../../../../App";

import { setOnCall } from "../../../../app/userState/userStateSlice";
import ringtone from "../../../../../public/sound/ringtone.mp3";
import useSound from "use-sound";

interface IProps {
    streamName: string;
    handleStreamName(name: string): void;
    handleChangeRoomStatus(status: string): void;
    meetingStatus: string
}

const MiniVideoCallControl: FC<IProps> = ({ handleChangeRoomStatus, handleStreamName, meetingStatus }) => {
    const antmedia = useContext(AntmediaContext);

    const dispatch = useAppDispatch();
    const { user } = useAppSelector((state) => state.auth);
    const { incomingRoom } = useAppSelector((state) => state.chat);
    const { vCallState, vCallIncomingMessage } = useAppSelector((state) => state.vcall);
    const { floatingLocation, overlay } = useAppSelector((state) => state.layoutstate);

    const [callConnected, setCallConnected] = useState(false);
    const [pickedUp, setPickedUp] = useState(false);
    const [ringing, setRinging] = useState(true);
    const [callTime] = useState(Date.now());
    const [callDescription, setCallDescription] = useState(`Incoming video call...`);
    const [callId, setCallId] = useState("")
    const [rejected] = useState(false)
    const [busyIntervalId, setBusyIntervalId] = useState(0)
    const callnotifWidth = 260;
    const locationX = floatingLocation.x === 0 ? (screen.width - callnotifWidth) / 2 : floatingLocation.x
    const locationY = floatingLocation.y === 0 ? floatingLocation.y + 99 : floatingLocation.y
    const [fullscreen] = useState(false);
    const { ref, x, y, isDragging, setPos } = useDragging(locationX, locationY, 260, 256);
    const [ready, setReady] = useState(false)
    const [play, { stop }] = useSound(ringtone);
    const notifyDialResult = (dialresult: string) => {

        const activecall = {
            CallId: callId
            , CalleeStreamId: "agentStream" + String(user?.deviceId)
            , CallerStreamId: vCallIncomingMessage.deviceid
            , Callee: user?.username
            , Caller: vCallIncomingMessage.username
            , DialResult: dialresult
            , CallTime: toIsoString(new Date(callTime))
            , DisconnectedTime: dialresult === "Ringing" || dialresult === "Answer" ? undefined : toIsoString(new Date())
            , Channel: "video"
            , SubscriptionId: process.env.REACT_APP_SUBSCRIPTIONID
            , SessionId: vCallIncomingMessage.sessionid
            , CallType: vCallIncomingMessage.calltype
        }
        const payload = {
            requesttype: "DialResult"
            , ActiveCall: activecall
        }
        dispatch(vCallSendMessage({
            content:
                JSON.stringify(payload)
        }));
    }
    const resetIncomingCall = () => {
        dispatch(vCallIncomingMessageReceived({} as IVCallIncomingMessage));
        dispatch(vCallStateChanged({} as IVCallState));

    }
    const answerCall = () => {
        stop()
        handleStreamName(user?.username ?? "")
        clearInterval(busyIntervalId)
        setRinging(false);
        setPickedUp(true);
        setCallConnected(true);
        setCallDescription("Answered");
        notifyDialResult("Answer")
        let sessionid = incomingRoom.find(z => z.roomId == vCallIncomingMessage.roomId)?.sessionId
        if (sessionid === undefined || sessionid === "")
            sessionid = uid(36)
        const vcstate = { ...vCallState };
        vcstate.SessionId = String(sessionid)
        vcstate.roomId = vCallIncomingMessage.roomId
        vcstate.username = vCallIncomingMessage.username
        vcstate.name = vCallIncomingMessage.username
        vcstate.isCalling = true;
        vcstate.connectedTime = now()
        vcstate.CallId = callId
        dispatch(vCallStateChanged(vcstate));
        setPos({
            x: x - 260,
            y: y,
        })

        handleChangeRoomStatus("meeting-video-dms");
    }



    const Busy = () => {
        stop()
        setRinging(false);
        setPickedUp(false);
        setCallDescription("Missed Call. You were busy.")
        notifyDialResult("Busy");
        dispatch(setOnCall(""));
        resetIncomingCall();

    }
    const BusyTimer = () => {
        let i = 0;
        let sentRinging = false;
        const tmr = window.setInterval(() => {
            if (callId !== "" && !sentRinging) {
                notifyDialResult("Ringing")
                sentRinging = true
            }
            i++;
            if (i > 20) {
                if (!callConnected && !rejected) {

                    Busy()
                    handleChangeRoomStatus("missing-video-dms")
                }
                window.clearInterval(tmr)
            }
        }, 1000);
        setBusyIntervalId(tmr)
    }

    const closeModal = () => {
        antmedia.turnOffLocalCamera("localVideo");
        window.clearInterval(busyIntervalId)
        handleChangeRoomStatus("close")
        dispatch(setOnCall(""))
        resetIncomingCall();

    }
    useEffect(() => {
        if (meetingStatus === "waiting-video-dms") {
            setPickedUp(false)
            setRinging(true);
            BusyTimer()
            setCallDescription("Incoming video call...")
        }

    }, [meetingStatus])


    const callButton = (<>

        <div className="flex flex-row justify-center h-[68px] w-[100%] justify-center gap-[36px]">

            <div className="flex flex-col items-center gap-[8px]">
                <Button shape="ellipse" onClick={() => answerCall()} type="button" variant="contained" color="primary" iconButton className="w-[44px] h-[44px]">
                    <VideoOnIcon className="w-6 h-6 text-white" />

                </Button>
                <span className="text-white text-base font-semibold">Accept</span>
            </div>
        </div>
    </>)



    const initVideo = () => {
        antmedia.initialize({ audioOnly: false });
        setTimeout(() => {
            antmedia.turnOffLocalCamera();
        }, 1000);
        const checkCam = setInterval(() => {
            console.log("Checking......")
            if (antmedia.mediaManager.localStream) {
                antmedia.mediaManager.localVideo = document.getElementById("localVideo");
                if (antmedia.mediaManager.localVideo) {
                    (antmedia.mediaManager.localVideo as HTMLVideoElement).srcObject = antmedia.mediaManager.localStream;
                    clearInterval(checkCam);
                }

                antmedia.turnOffLocalCamera();
                window.clearInterval(checkCam);

            }

        }, 500);
    }
    useEffect(() => {
        play()
        setCallId(uid(21))
        initVideo()
        setReady(true)
        return () => {
            stop()
        }
    }, [])
    useEffect(() => {
        if (ready)
            if (!isDragging)
                dispatch(setFloatingCoordinate({ x, y }));
    }, [isDragging])



    return (
        <>
            <div onClick={() => dispatch(setOverlay(false))} onKeyDown={() => { }} role="none" className={clsx("fixed z-[19] w-screen h-screen flex justify-center items-center bg-gray-900 opacity-[0.2] duration-700",
                !overlay && "hidden"
            )}>
            </div>
            <div

                style={{
                    left: x,
                    top: y,
                }}
                className={clsx(
                    isDragging && "bg-geyser",
                    !isDragging && "bg-white",
                    pickedUp && !fullscreen && "w-[520px]",
                    !pickedUp && !fullscreen && "w-[260px]",
                    fullscreen && "w-[100%]",

                    `absolute shadow-sm rounded-lg bg-white z-[21] absolute overflow-hidden`
                )}>

                <div className="flex flex-col justify-between p- min-h-[180px] items-center overflow-hidden">

                    <div className={
                        clsx("w-[100%] h-[100%] rounded-lg p-[10px] absolute top-[0px]",
                            !pickedUp && " bg-black/[.30]"
                        )}
                    >

                        <div ref={ref} className="draggable flex flex-col-reverse justify-between h-[100%] items-center justify-between gap-[8px]">
                            <div className="h-[68px]">
                                {(ringing || pickedUp) && callButton}
                                {(!ringing && !pickedUp) &&
                                    (
                                        <div className="flex flex-row justify-center h-[68px] w-[100%] justify-center gap-[36px] -mt-[20px]">
                                            <Button shape="ellipse" onClick={() => { }} type="button" variant="contained" color="danger" iconButton className="w-[44px] h-[44px]">
                                                <SadIcon className="w-6 h-6 text-white" />
                                            </Button>
                                        </div>
                                    )
                                }

                            </div>
                            {
                                !pickedUp ? (<>
                                    <div className="flex flex-col items-center justify-between pb-[20px]">
                                        <div className="text-lg font-semibold text-white">
                                            {vCallIncomingMessage.username}

                                        </div>
                                        <div className="text-base font-normal text-white">{callDescription}</div>

                                    </div>

                                </>) : <></>
                            }
                            <div className="flex flex-row justify-between w-[100%]">
                                <div className="text-md text-white self-end z-[1000] p-[2px] rounded-lg text-black"></div>
                                {!pickedUp ? (<>
                                    <div role="button" tabIndex={-1}
                                        onKeyDown={
                                            closeModal
                                        }
                                        onClick={
                                            closeModal
                                        } className="text-md text-white self-end"><CloseIcon className="w-[16px] h-[16px]" width={24} height={24} />
                                    </div>
                                </>) : <></>}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MiniVideoCallControl;
